import React, { useState, Fragment, useEffect } from 'react';
import { Tooltip } from 'reactstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import categoryBotResponseCodeMapping from '../../../../../../data/categoryBotResponseCodeMapping';
import ProductImage from "./ProductImage";
import {
  Row,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faArrowRight } from '@fortawesome/free-solid-svg-icons';

import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import CustomSelectInput from '../../../../../../components/common/CustomSelectInput';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
} from '../../../../../../helpers/AxiosAPI';
import {
  postAPI_Create_Business,
  gAPI_Business_By_Id,
  putAPI_Update_Business,
  putAPI_Delete_Business,
  gAPI_QuestionOptionList,
  gAPI_FormsBy_PropertyId,
  gAPI_Vouchers_List,
  gAPI_Users_By_Id,
  gAPI_Internal_Property_By_Id,
} from '../../../../../../constants/APIs';
import ImageGallery from '../../gallery/index';
import Select from 'react-select';
import Validation from '../../../../../../components/Validation';
import CategoryTag from './CategoryTag';
import no_image from '../../../../../../assets/no_image.png';
const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image'],
    ['clean'],
  ],
};
const quillFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
];
export function AddNewBusiness({
  id,
  visible,
  toggleModal,
  formLabel,
  propertyId,
  domains,
  LoadData,
  categoryList,
  locale,
}) {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [visibleImage, setVisibleImage] = useState(false);
  const [selectedOptions, setselectedOptions] = useState([]);
  const [selectedTags, setselectedTags] = useState([]);
  const [tags, setTags] = useState([]);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [categoriesData, setCategoriesData] = useState([
    ...categoryList,
    { label: 'Add New', value: 'new' },
  ]);
  const [addCategoryVisible, setAddCategoryVisible] = useState(false);
  const [editCategoryVisible, setEditCategoryVisible] = useState(false);
  const [isAivaProperty, setIsAivaProperty] = useState(false);
  const [formsData, setFormsData] = useState([]);
  const [vouchers, setVouchers] = useState([]);
  const [isIframe, setIsIframe] = useState(false);
  const [isIframeTop, setIsIframeTop] = useState(false);
  const [isThirdParty, setIsThirdParty] = useState(false);

  // const categoriesData = [
  //     { label: "Activities", value: "Activities", key: 0 },
  //     // { label: "Mountain - Rangi", value: "Mountain - Rangi", key: 1 },
  //     // { label: "Land – Whenua", value: "Land – Whenua", key: 2 },
  //     // { label: "Moana – Sea", value: "Moana – Sea", key: 3 },
  //     { label: "Accommodation", value: "Accommodation", key: 1 },
  //     // { label: "Motel & Apartments", value: "Motel & Apartments", key: 5 },
  //     // { label: "Backpackers & Hostels", value: "Backpackers & Hostels", key: 6 },
  //     // { label: "Bed & Breakfast", value: "Bed & Breakfast", key: 7 },
  //     // { label: "Boutique & Lodge", value: "Boutique & Lodge", key: 8 },
  //     // { label: "NZ Luxury Lodge", value: "NZ Luxury Lodge", key: 9 },
  //     // { label: "Glamping & Camping", value: "Glamping & Camping", key: 10 },
  //     { label: "Holiday Homes", value: "Holiday Homes", key: 2 },
  //     { label: "Food & Drink", value: "Food & Drink", key: 3 },
  //     // { label: "Restaurants & Bars", value: "Restaurants & Bars", key: 13 },
  //     // { label: "Cafes", value: "Cafes", key: 14 },
  //     // { label: "Takeaways", value: "Takeaways", key: 15 },
  //     { label: "Retail", value: "Retail", key: 4 }
  // ];

  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };
  const selectedImage = (image) => {
    setBusinessData({
      ...buisnessData,
      imageLink: image.src,
    });
  };

  const handleRemoveImage = () => {
    setBusinessData({
      ...buisnessData,
      imageLink: '',
    });
  };

  const [buisnessData, setBusinessData] = useState({
    groupId: getGroupID(),
    propertyId: propertyId,
    title: [
      {
        statement: '',
        languageCode: 'en',
      },
    ],
    name: [
      {
        statement: '',
        languageCode: 'en',
      },
    ],
    shortDescription: [
      {
        statement: '',
        languageCode: 'en',
      },
    ],
    longDescription: [
      {
        statement: '',
        languageCode: 'en',
      },
    ],
    conditions: [
      {
        statement: '',
        languageCode: 'en',
      },
    ],
    status: 'Active',
    type: 'Product',
    detailsButton: 'Redirect',
    displayOrder: 0,
    buyButton: 'Redirect',
    categories: [],
    tags: [],
    priceRangeStart: 0,
    priceRangeEnd: 0,
    promoPriceRangeStart: 0,
    promoPriceRangeEnd: 0,
    phone: '',
    website: '',
    categories: [],
    email: '',
    address: '',
    features: '',
    googleMap: '',
    facebookLink: '',
    instagramLink: '',
    detailsLink: '',
    bookingLink: '',
    twitterLink: '',
    videoLink: '',
    imageLink: '',
    imageLinks: [],
    creator: 'dashboard',
    action: 'None',
    actionValue: {
      valueId: '',
      valueName: '',
      externalUrl: '',
      promoCode: '',
      instructions: [
        {
          statement: '',
          languageCode: 'en',
        },
      ],
      submitButtonText: [
        {
          statement: '',
          languageCode: 'en',
        },
      ],
    },
    embedIframe: '',
    embedIframeTop: '',
  });

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_FormsBy_PropertyId}?groupId=${getGroupID()}&propertyId=${propertyId}&lang=${locale}`,
    })
      .then((res) => {
        setFormsData(res.data);
      })
      .catch((err) => console.error(err));
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    }).then((res) => {
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Vouchers_List}?groupId=${getGroupID()}&propertyId=${propertyId}&languageCode=${locale}&search=&status=All&pageNumber=${1}&pageSize=${100}&email=${res.data.email
          }`,
      }).then((res) => {
        if (
          res.data.vouchers !== undefined &&
          res.data.vouchers !== null &&
          res.data.vouchers.length > 0
        ) {
          var voucherData = res.data.vouchers.filter(
            (item) => item.status !== 'Draft'
          );
          setVouchers(voucherData);
        }
      });
    });
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        setIsAivaProperty(res.data.isAiva);
      })
      .catch((err) => console.error(err));
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Business_By_Id}/${id}`,
      })
        .then((res) => {
          setBusinessData(res.data);
          if (res.data.createdBy === 'Farehourbor' || res.data.createdBy === 'Rezdy' || res.data.createdBy === 'Ways') {
            setIsThirdParty(true);
          }
          if (
            res.data.embedIframe &&
            res.data.embedIframe !== null &&
            res.data.embedIframe !== ''
          ) {
            setIsIframe(true);
          }
          if (
            res.data.embedIframeTop &&
            res.data.embedIframeTop !== null &&
            res.data.embedIframeTop !== ''
          ) {
            setIsIframeTop(true);
          }
          var selectedcategories = [];
          try {
            res.data.categories.map((item) =>
              selectedcategories.push(
                categoriesData.filter((cat) => cat.value === item)[0]
              )
            );
          } finally {
          }
          setselectedOptions(selectedcategories);
          AxiosAPI({
            method: 'get',
            url: `${gAPI_QuestionOptionList}?propertyId=${propertyId}&type=Products`,
          })
            .then((res1) => {
              var options = [];
              try {
                res1.data.map((item) =>
                  options.push({
                    label: item.option,
                    value: item.option,
                    key: item.id,
                  })
                );
              } finally {
              }
              setTags(options);

              var selectedTags = [];

              try {
                res.data.tags.map((item) =>
                  selectedTags.push(
                    options.filter((cat) => cat.value === item)[0]
                  )
                );
              } finally {
              }
              setselectedTags(selectedTags);
            })
            .catch((err) => console.log('err', err));
        })
        .catch((err) => console.log('err', err));
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_QuestionOptionList}?propertyId=${propertyId}&type=Products`,
      })
        .then((res) => {
          var options = [];
          try {
            res.data.map((item) =>
              options.push({
                label: item.option,
                value: item.option,
                key: item.id,
              })
            );
          } finally {
          }
          setTags(options);
        })
        .catch((err) => console.log('err', err));
    }
  }, [id]);

  const handleChangeMulti = (selectedOptions) => {
    if (isThirdParty) {
    } else if (selectedOptions.filter((i) => i.value === 'new').length === 0) {
      setselectedOptions(selectedOptions);
      const categoriesArr = selectedOptions.map((elem) => elem.value);

      setBusinessData({
        ...buisnessData,
        categories: categoriesArr,
      });
    } else {
      setAddCategoryVisible(true);
    }
  };
  const handleChangeActionValueArr = (e) => {
    var actionvalue = { ...buisnessData };
    if (actionvalue.actionValue !== null) {
      var value = { ...actionvalue.actionValue };
      if (e.target.name === 'submitButtonText') {
        if (
          value.submitButtonText !== null &&
          value.submitButtonText.length > 0
        ) {
          const index = value.submitButtonText.findIndex(
            (m) => m.languageCode === locale
          );
          if (index === -1) {
            const newStatement = {
              statement: e.target.value,
              languageCode: locale,
            };
            value.submitButtonText = [...value.submitButtonText, newStatement];
          } else {
            let newArr = [...value.submitButtonText];
            newArr[index].statement = e.target.value;
            value.submitButtonText = newArr;
          }
        } else {
          const newStatement = {
            statement: e.target.value,
            languageCode: locale,
          };
          value.submitButtonText = [newStatement];
        }
      } else if (e.target.name === 'instructions') {
        if (value.instructions !== null && value.instructions.length > 0) {
          const index = value.instructions.findIndex(
            (m) => m.languageCode === locale
          );
          if (index === -1) {
            const newStatement = {
              statement: e.target.value,
              languageCode: locale,
            };
            value.instructions = [...value.instructions, newStatement];
          } else {
            let newArr = [...value.instructions];
            newArr[index].statement = e.target.value;
            value.instructions = newArr;
          }
        } else {
          const newStatement = {
            statement: e.target.value,
            languageCode: locale,
          };
          value.instructions = [newStatement];
        }
      }
      setBusinessData({
        ...buisnessData,
        actionValue: value,
      });
    }
  };
  const handleAddCategoryTag = (data, oldtitle) => {
    let allcate = [...categoriesData];
    let selectedCate = [...selectedOptions];
    var newVariable = { label: data, value: data };
    selectedCate.push(newVariable);
    allcate.push(newVariable);
    if (oldtitle !== undefined) {
      selectedCate = selectedCate
        .filter((l) => l.value !== oldtitle)
        .map((l) => l);
      allcate = allcate.filter((l) => l.value !== oldtitle).map((l) => l);
    }
    setCategoriesData(allcate);
    setselectedOptions(selectedCate);
    setBusinessData({
      ...buisnessData,
      categories: selectedCate.map((l) => l.value),
    });
  };

  const handleChangeTags = (selectedTags) => {
    setselectedTags(selectedTags);
    const tagsArr = selectedTags.map((elem) => elem.value);

    setBusinessData({
      ...buisnessData,
      tags: tagsArr,
    });
  };

  const handleChange = (e) => {
    setBusinessData({
      ...buisnessData,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeArr = (e) => {
    const key = e.target.name;
    const value = e.target.value;
    setBusinessData({
      ...buisnessData,
      [key]: [
        {
          statement: value,
          languageCode: 'en',
        },
      ],
    });
  };

  const handleDelete = () => {
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Delete_Business}/${id}`,
      data: {
        deleter: 'dashboard',
      },
    })
      .then((res) => {
        setTimeout(() => {
          toggleModal();
          LoadData();
        }, 1000);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getLocalStatement = (statements) => {
    if (
      statements !== undefined &&
      statements !== null &&
      statements.length > 0
    ) {
      const index = statements.findIndex((m) => m.languageCode === locale);
      if (index === -1) {
        const englishIndex = statements.findIndex(
          (m) => m.languageCode === 'en'
        );
        if (englishIndex !== -1) {
          return statements[englishIndex].statement;
        }
      } else {
        return statements[index].statement;
      }
    } else {
      return '';
    }
  };
  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This business will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <ImageGallery
                    propertyId={propertyId}
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  const handleSignUpAiva = () => {
    window.open('https://app.getaiva.com/user/vouchersignup');
  };
  const handleLearnMoreAiva = () => {
    window.open('https://getaiva.com/');
  };

  const handleChangeActionValue = (e) => {
    var actionvalue = { ...buisnessData };
    if (actionvalue.actionValue !== null) {
      var value = { ...actionvalue.actionValue };
      value[e.target.name] = e.target.value;
      setBusinessData({
        ...buisnessData,
        actionValue: value,
      });
    }
  };

  const handleChangeVoucher = (e) => {
    var voucher = vouchers
      .filter((item) => item.id === e.target.value)
      .map((i) => i.name);
    let voucherName = '';
    if (voucher.length > 0) {
      voucherName = voucher[0];
    }
    var actionvalue = { ...buisnessData };
    if (actionvalue.actionValue !== null) {
      var value = { ...actionvalue.actionValue };
      value.valueId = e.target.value;
      value.valueName = voucherName;
      setBusinessData({
        ...buisnessData,
        actionValue: value,
      });
    }
  };

  const handleChangeForm = (e) => {
    let formId = e.target.value;
    let formName = '';
    var form = formsData.filter((item) => item.id === e.target.value);
    if (form.length > 0) {
      formName = form[0].name;
    }
    var actionvalue = { ...buisnessData };
    if (actionvalue.actionValue !== null) {
      var value = { ...actionvalue.actionValue };
      value.valueId = formId;
      value.valueName = formName;
      setBusinessData({
        ...buisnessData,
        actionValue: value,
      });
    }
  };

  const handleSubmit = () => {
    if (id !== undefined) {
      const formmatedData = { ...buisnessData, Updater: 'admin' };

      AxiosAPI({
        method: 'put',
        url: `${putAPI_Update_Business}/${id}`,
        data: formmatedData,
      })
        .then((res) => {
          if (
            res.data.HttpStatusCode !== undefined &&
            res.data.HttpStatusCode === 400 &&
            res.data.Messages !== undefined &&
            res.data.Messages !== null &&
            res.data.Messages.length > 0
          ) {
            setMsg(res.data.Messages);
            setOpen(true);
          } else {
            setTimeout(() => {
              toggleModal();
              LoadData();
            }, 1000);
          }
        })
        .catch((err) => {
          console.log('err', err);
        });
    } else {
      const formmatedData = { ...buisnessData };
      AxiosAPI({
        method: 'post',
        url: `${postAPI_Create_Business}`,
        data: formmatedData,
      })
        .then((res) => {
          if (
            res.data.HttpStatusCode !== undefined &&
            res.data.HttpStatusCode === 400 &&
            res.data.Messages !== undefined &&
            res.data.Messages !== null &&
            res.data.Messages.length > 0
          ) {
            setMsg(res.data.Messages);
            setOpen(true);
          } else {
            setTimeout(() => {
              toggleModal();
              LoadData();
            }, 1000);
          }
        })
        .catch((err) => {
          console.log('err', err);
        });
    }
  };
  const handleImagesDone = (images) => {
    setBusinessData({
      ...buisnessData,
      imageLinks: images
    });
  };
  const handleChangeHighlightsArr = (source, e) => {
    if (isThirdParty) {
    } else if (source === 'user') {
      if (buisnessData.longDescription.length > 0) {
        const index = buisnessData.longDescription.findIndex(
          (m) => m.languageCode === locale
        );
        if (index === -1) {
          const newStatement = {
            statement: e,
            languageCode: locale,
          };
          setBusinessData({
            ...buisnessData,
            longDescription: [...buisnessData.longDescription, newStatement],
          });
        } else {
          let newArr = [...buisnessData.longDescription];
          newArr[index].statement = e;
          setBusinessData({
            ...buisnessData,
            longDescription: newArr,
          });
        }
      } else {
        const newStatement = {
          statement: e,
          languageCode: locale,
        };
        setBusinessData({
          ...buisnessData,
          longDescription: [...buisnessData.longDescription, newStatement],
        });
      }
    }
  };
  return (
    <Fragment>
      <Modal
        isOpen={visible}
        toggle={toggleModal}
        wrapClassName="modal-right"
        backdrop="static"
      >
        <ModalHeader toggle={toggleModal}>{formLabel}</ModalHeader>
        {buisnessData != undefined && (
          <ModalBody>
            {/* <pre>{JSON.stringify(buisnessData, null, 2)}</pre> */}
            <Label className="mt-3">Title</Label>
            <Input
              type="text"
              onChange={handleChangeArr}
              value={
                buisnessData.title != null
                  ? buisnessData.title[0].statement
                  : ''
              }
              name="title"
              disabled={isThirdParty}
              placeholder=""
            />
            <div className="row">
              <div className="col-12">
                {isIframeTop ? (
                  <Fragment>
                    <Label className="mt-3">Embed Iframe</Label>
                    <Input
                      type="textarea"
                      onChange={handleChange}
                      value={buisnessData.embedIframeTop}
                      name="embedIframeTop"
                      placeholder={'Enter Iframe'}
                    />
                  </Fragment>
                ) : (
                  <Button
                    color="primary"
                    className="mt-3"
                    size="xs"
                    outline
                    onClick={() => setIsIframeTop(true)}
                  >
                    +Embed Iframe
                  </Button>
                )}
              </div>
            </div>
            <Label className="mt-3">Highlights</Label>
            <ReactQuill
              theme="snow"
              value={getLocalStatement(buisnessData.longDescription)}
              onChange={(content, delta, source) =>
                handleChangeHighlightsArr(source, content)
              }
              modules={quillModules}
              formats={quillFormats}
              name="longDescription"

            />
            <div className="row">
              <div className="col-12">
                {isIframe ? (
                  <Fragment>
                    <Label className="mt-3">Embed Iframe</Label>
                    <Input
                      type="textarea"
                      onChange={handleChange}
                      value={buisnessData.embedIframe}
                      name="embedIframe"
                      placeholder={'Enter Iframe'}
                    />
                  </Fragment>
                ) : (
                  <Button
                    color="primary"
                    className="mt-3"
                    size="xs"
                    outline
                    onClick={() => setIsIframe(true)}
                  >
                    +Embed Iframe
                  </Button>
                )}
              </div>
            </div>
            <Label className="mt-3">Status</Label>
            <Input
              type="select"
              name="status"
              value={buisnessData.status}
              onChange={handleChange}
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </Input>
            <Label className="mt-3">Categories</Label>
            <Select
              components={{ Input: CustomSelectInput }}
              className="react-select"
              classNamePrefix="react-select"
              isMulti={true}
              name="form-field-name"
              value={selectedOptions}
              disabled={isThirdParty}
              onChange={handleChangeMulti}
              options={categoriesData}
            />
            {!isThirdParty && categoriesData.length > 1 && (
              <div className="d-flex justify-content-end mt-2">
                <Button
                  outline
                  color="primary"
                  size="xs"
                  onClick={() => {
                    setEditCategoryVisible(!editCategoryVisible);
                    setAddCategoryVisible(true);
                  }}
                >
                  <FontAwesomeIcon icon={faEdit} />
                  {''}
                  <IntlMessages id="survey.edit" />{' '}
                  <IntlMessages id="survey.category" />
                </Button>
              </div>
            )}

            <Label><IntlMessages id='dashboards.displayOrder' /> </Label>
            <Input
              type="number"
              min={0}
              name="displayOrder"
              value={buisnessData.displayOrder}
              onChange={handleChange}
            />

            <Label className="mt-3">Tags</Label>
            <Select
              components={{ Input: CustomSelectInput }}
              className="react-select"
              classNamePrefix="react-select"
              isMulti={true}
              name="form-field-name"
              value={selectedTags}
              onChange={handleChangeTags}
              options={tags}
            />
            <Label className="mt-3">Order/Buy Method</Label>
            <Input
              type="select"
              name="action"
              value={buisnessData.action}
              disabled={isThirdParty}
              onChange={handleChange}
            >
              <option value="0">Select</option>
              <option value="ExternalURL">External URL</option>
              <option value="PromoCode">Promo Code</option>
              <option value="aiva">aiva</option>
              <option value="CreateTicket">Create Ticket (Pre Check-in)</option>
              <option value="CreateTicketInStay">
                Create Ticket (In Stay)
              </option>
              <option value="TakePayment">Take Payment</option>
              <option value="SubmitForm">Submit Form</option>
            </Input>
            {buisnessData.action === 'PromoCode' && (
              <div className="row">
                <div className="col-12">
                  <Label className="mt-3">Promo Code</Label>
                  <Input
                    type="text"
                    onChange={handleChangeActionValue}
                    value={buisnessData.actionValue.promoCode}
                    name="promoCode"
                    placeholder="Promo Code"
                  />
                </div>
                <div className="col-12">
                  <Label className="mt-3">External Link (Url)</Label>
                  <Input
                    type="text"
                    onChange={handleChangeActionValue}
                    value={buisnessData.actionValue.externalUrl}
                    name="externalUrl"
                    disabled={isThirdParty}
                    placeholder="External Link (Url)"
                  />
                </div>
                <div className="col-12">
                  <Label className="mt-3">Instructions</Label>
                  <Input
                    type="textarea"
                    onChange={handleChangeActionValueArr}
                    value={getLocalStatement(
                      buisnessData.actionValue.instructions
                    )}
                    disabled={isThirdParty}
                    name="instructions"
                    placeholder="Instructions"
                  />
                </div>
              </div>
            )}
            {buisnessData.action === 'ExternalURL' && (
              <div className="row">
                <div className="col-12">
                  <Label className="mt-3">External Link (Url)</Label>
                  <Input
                    type="text"
                    onChange={handleChangeActionValue}
                    value={buisnessData.actionValue.externalUrl}
                    name="externalUrl"
                    disabled={isThirdParty}
                    placeholder="External Link (Url)"
                  />
                </div>
                <div className="col-12">
                  <Label className="mt-3">Instructions</Label>
                  <Input
                    type="textarea"
                    onChange={handleChangeActionValueArr}
                    value={getLocalStatement(
                      buisnessData.actionValue.instructions
                    )}
                    name="instructions"
                    disabled={isThirdParty}
                    placeholder="Instructions"
                  />
                </div>
                <div className="col-12">
                  <Label className="mt-3">Action Button Text</Label>
                  <Input
                    type="text"
                    value={getLocalStatement(
                      buisnessData.actionValue.submitButtonText
                    )}
                    disabled={isThirdParty}
                    onChange={handleChangeActionValueArr}
                    name="submitButtonText"
                    placeholder="Action Button Text"
                  />
                </div>
              </div>
            )}
            {buisnessData.action === 'SubmitForm' ? (
              <Fragment>
                <Label className="mt-3">Select Forms</Label>
                <Input
                  type="select"
                  name="forms"
                  value={buisnessData.actionValue.valueId}
                  onChange={handleChangeForm}
                >
                  <option value="">Select</option>
                  {formsData &&
                    formsData.map((item, i) => (
                      <option value={item.id} key={i}>
                        {item.name}
                      </option>
                    ))}
                </Input>
                {buisnessData.actionValue.valueId !== '' && (
                  <Fragment>
                    <Label className="mt-3">Action Button Text</Label>
                    <Input
                      type="text"
                      value={getLocalStatement(
                        buisnessData.actionValue.submitButtonText
                      )}
                      onChange={handleChangeActionValueArr}
                      name="submitButtonText"
                      placeholder="Action button Text"
                    />
                  </Fragment>
                )}
              </Fragment>
            ) : null}
            {isAivaProperty === true && buisnessData.action === 'aiva' ? (
              <Fragment>
                <Label className="mt-3">Select Voucher(s)</Label>
                <Input
                  type="select"
                  name="vouchers"
                  value={buisnessData.actionValue.valueId}
                  onChange={handleChangeVoucher}
                >
                  <option value="">Select</option>
                  {vouchers.length > 0 &&
                    vouchers.map(
                      (item) =>
                        item.name !== '' && (
                          <option value={item.id}>{item.name}</option>
                        )
                    )}
                </Input>
              </Fragment>
            ) : (
              buisnessData.action === 'aiva' && (
                <div className="text-center p-2 mt-2">
                  <p style={{ fontSize: '15px' }}>
                    <b>aiva</b> is an automated, direct sell voucher system
                    allowing you to offer fully branded vouchers on your
                    website.{' '}
                  </p>
                  <p className="mt-3" style={{ fontSize: '15px' }}>
                    Currently, you do not have an account for <b>aiva</b>. It's
                    quick, inexpensive, simple and smart. Ten minutes is all it
                    takes to sign-up and upload your first voucher.
                  </p>
                  <div
                    className="d-flex"
                    style={{
                      flexDirection: 'column',
                      alignContent: 'center',
                      flexWrap: 'wrap',
                    }}
                  >
                    <Button
                      style={{ marginTop: '20px' }}
                      color="primary"
                      onClick={() => handleLearnMoreAiva()}
                      size="xs"
                    >
                      Learn More <FontAwesomeIcon icon={faArrowRight} />
                    </Button>
                    <Button
                      style={{ marginTop: '20px' }}
                      color="primary"
                      onClick={() => handleSignUpAiva()}
                      size="xs"
                    >
                      Sign Up <FontAwesomeIcon icon={faArrowRight} />
                    </Button>
                  </div>
                </div>
              )
            )}
            {buisnessData.actionValue.valueId !== null &&
              buisnessData.actionValue.valueId !== '' &&
              buisnessData.actionValue.valueName !== null &&
              buisnessData.actionValue.valueName !== '' &&
              buisnessData.action === 'aiva' && (
                <div className="text-left p-2 mt-2">
                  <span>
                    <a
                      href={
                        `${process.env.REACT_APP_VOUCHERAIVA_URL}/vhp?id=` +
                        buisnessData.actionValue.valueId
                      }
                      rel="noopener noreferrer"
                      target="_blank"
                      style={{ textDecoration: 'underline', fontWeight: '600' }}
                    >
                      Click here
                    </a>{' '}
                    to view the voucher
                  </span>
                  <br />
                </div>
              )}
            {/* <Label className="mt-3">
                            Selling Style (How to want Buy button to behave)
                        </Label>
                        <Input
                            type="select"
                            name="buyButton"
                            value={buisnessData.buyButton}
                            onChange={handleChange}
                        >

                            <option value="Redirect">Redirect to the business booking page</option>
                            <option value="UrlWebView">Open business booking page in bot</option>
                            <option value="PrintPromo">Offer a promo code</option>
                            <option value="SellVoucher">Sell a voucher</option>

                        </Input> */}
            {/* <Label className="mt-3">
                            Buisness Name
                        </Label>
                        <Input
                            type="text"
                            onChange={handleChangeArr}
                            value={buisnessData.name != null ? buisnessData.name[0].statement : ''}
                            name="name"
                            placeholder=""
                        /> */}

            {/* <Label className="mt-3">
                            Type
                        </Label>
                        <Input
                            type="select"
                            name="type"
                            value={buisnessData.type}
                            onChange={handleChange}
                        >

                            <option value="Product">Product</option>
                            <option value="Promotion">Promotion</option>

                        </Input> 
                        <Label className="mt-3">
                            Details Style (Show you Details button to behave)
                        </Label>
                        <Input
                            type="select"
                            name="detailsButton"
                            value={buisnessData.detailsButton}
                            onChange={handleChange}
                        >

                            <option value="Redirect">Redirect to the business details page</option>
                            <option value="UrlWebView">Open business details page in bot</option>
                            <option value="CustomWebView">Open business details from bot</option>

                        </Input>*/}

            {/* <Label className="mt-3">
                            Selling Style (How to want Buy button to behave)
                        </Label>
                        <Input
                            type="select"
                            name="buyButton"
                            value={buisnessData.buyButton}
                            onChange={handleChange}
                        >

                            <option value="Redirect">Redirect to the business booking page</option>
                            <option value="UrlWebView">Open business booking page in bot</option>
                            <option value="PrintPromo">Offer a promo code</option>
                            <option value="SellVoucher">Sell a voucher</option>

                        </Input>
                        <Label className="mt-3">
                            Short Description
                        </Label>

                        <Input
                            type="textarea"
                            onChange={handleChangeArr}
                            value={buisnessData.shortDescription != null ? buisnessData.shortDescription[0].statement : ''}
                            name="shortDescription"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Long Description
                        </Label>

                        <Input
                            type="textarea"
                            onChange={handleChangeArr}
                            value={buisnessData.longDescription != null ? buisnessData.longDescription[0].statement : ''}
                            name="longDescription"
                            placeholder=""
                        /> */}
            {/* <Label className="mt-3">
                            Conditions
                        </Label>

                        <Input
                            type="textarea"
                            onChange={handleChangeArr}
                            value={buisnessData.conditions != null ? buisnessData.conditions[0].statement : ''}
                            name="conditions"
                            placeholder=""
                        /> */}

            {/* <Label className="mt-3">Price Range  </Label>
                        <div className="row">
                            <div className="col-5">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">$</InputGroupAddon>
                                    <Input
                                        required
                                        name="priceRangeStart"
                                        type="number"
                                        min="0"
                                        value={buisnessData.priceRangeStart}
                                        onChange={handleChange}
                                    />
                                </InputGroup>

                            </div>
                            <div className="col-2 mt-3">
                                to
                            </div>
                            <div className="col-5">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">$</InputGroupAddon>
                                    <Input
                                        required
                                        name="priceRangeEnd"
                                        type="number"
                                        min="0"
                                        value={buisnessData.priceRangeEnd}
                                        onChange={handleChange}
                                    />
                                </InputGroup>
                            </div>
                        </div>
                        <Label className="mt-3">Promotional Price Range  </Label>
                        <div className="row">
                            <div className="col-5">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">$</InputGroupAddon>
                                    <Input
                                        required
                                        name="promoPriceRangeStart"
                                        type="number"
                                        min="0"
                                        value={buisnessData.promoPriceRangeStart}
                                        onChange={handleChange}
                                    />
                                </InputGroup>

                            </div>
                            <div className="col-2 mt-3">
                                to
                            </div>
                            <div className="col-5">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">$</InputGroupAddon>
                                    <Input
                                        required
                                        name="promoPriceRangeEnd"
                                        type="number"
                                        min="0"
                                        value={buisnessData.promoPriceRangeEnd}
                                        onChange={handleChange}
                                    />
                                </InputGroup>
                            </div>
                        </div>
                        <Label className="mt-3">
                            Phone
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.phone}
                            name="phone"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Website
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.website}
                            name="website"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Email
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.email}
                            name="email"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Address
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.address}
                            name="address"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Features
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.features}
                            name="features"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Google Map
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.googleMap}
                            name="googleMap"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Details Link
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.detailsLink}
                            name="detailsLink"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Booking Link
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.bookingLink}
                            name="bookingLink"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Facebook Link
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.facebookLink}
                            name="facebookLink"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Instagram Link
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.instagramLink}
                            name="instagramLink"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Twitter Link
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.twitterLink}
                            name="twitterLink"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Video Link
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.videoLink}
                            name="videoLink"
                            placeholder=""
                        /> */}

            <Label className="mt-3">Primary Image</Label>
            <div className="text-center">
              {buisnessData.imageLink != null &&
                buisnessData.imageLink != '' ? (
                <div className="thumbnail">
                  <img
                    className="list-thumbnail responsive border-0"
                    src={buisnessData.imageLink}
                  />
                  <a
                    href="#/"
                    className="remove"
                    data-dz-remove
                    onClick={() => handleRemoveImage()}
                  >
                    {' '}
                    <i className="glyph-icon simple-icon-trash" />{' '}
                  </a>
                </div>
              ) : (
                <div className='thumbnail'>
                  <img className='list-thumbnail responsive border-0'
                    src={no_image}></img>
                </div>
              )}
              {isThirdParty ? null : (
                <Button
                  color="secondary"
                  className="mt-1"
                  onClick={togglegallery}
                >
                  <IntlMessages id='dashboards.browsegallery' />
                </Button>
              )}
            </div>
            <Label className="mt-3">Additional Images</Label>

            <ProductImage
              images={buisnessData?.imageLinks}
              visible={visibleImage}
              propertyId={propertyId}
              toggle={() => setVisibleImage(!visibleImage)}
              onDone={handleImagesDone}
            />
            <div style={{ display: "flex", flexWrap: "wrap" }}>

              {buisnessData?.imageLinks?.length > 0 &&
                buisnessData.imageLinks.map((img, index) => (

                  <div key={index} style={{ position: "relative", margin: "10px" }}>

                    <img
                      src={img}
                      alt="product"
                      style={{
                        width: "60px",
                        height: "60px",
                        objectFit: "cover",
                        borderRadius: "6px"
                      }}
                    />

                    <span
                      onClick={() => {
                        const updated = [...buisnessData?.imageLinks];
                        updated.splice(index, 1);

                        setBusinessData({
                          ...buisnessData,
                          imageLinks: updated
                        });
                      }}
                      style={{
                        position: "absolute",
                        top: "-5px",
                        right: "-5px",
                        cursor: "pointer",
                        color: "red",
                        fontWeight: "bold"
                      }}
                    >
                      ✕
                    </span>

                  </div>

                ))}

            </div>
            <div className='item-center'>
              <Button
                color="secondary"
                size="xs"
                className="mt-2"
                onClick={() => setVisibleImage(true)}
              >
                + Add Images
              </Button>
            </div>
          </ModalBody>
        )}
        <ModalFooter>
          {!isThirdParty &&
            <Button color="primary" onClick={handleSubmit}>
              Save
            </Button>
          }
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
          {id && (
            <Button color="danger" onClick={toggle}>
              Delete
            </Button>
          )}
        </ModalFooter>
      </Modal>
      {generateDeleteButton()}
      {ImageGalleryButton()}
      {
        addCategoryVisible && (
          <CategoryTag
            visible={addCategoryVisible}
            toggle={() => setAddCategoryVisible(!addCategoryVisible)}
            handleAddCategoryTag={handleAddCategoryTag}
            categoryList={categoriesData}
            isEdit={editCategoryVisible}
          ></CategoryTag>
        )
      }
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment >
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, domains, locale } = settings;
  return {
    propertyId,
    domains,
    locale,
  };
};

export default injectIntl(connect(mapStateToProps, {})(AddNewBusiness));
